import { Component, Input, ElementRef, EventEmitter, Output, ViewChild, OnInit, ViewEncapsulation, Renderer2, ContentChildren, QueryList, AfterViewInit, AfterContentInit } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { vp } from './vp.interface';
import { ViewPorts } from './viewports';
import { BrowserWindow } from './window';
import { UpsHamMenuItemComponent } from '../ups-ham-menu-item/ups-ham-menu-item.component';
declare var $: any;

@Component({
    selector: 'ups-ham-menu',
    template: require('./ups-ham-menu.component.html'),
    providers: [BrowserWindow, ViewPorts],
    encapsulation: ViewEncapsulation.None
})
export class UpsHamMenuComponent implements OnInit, AfterViewInit, AfterContentInit {

    globalClick: Function;
    globalKeydown: Function;
    closeFocusElm: HTMLElement;
    toggleMenuShown: boolean = false;
    vpSize: vp;
    focusedItemIndex: number = -1;
    focusableIndexes = [];

    @ViewChild('toggleDrawerContainer', { static: false }) toggleDrawerContainer: ElementRef;
    @ContentChildren(UpsHamMenuItemComponent) menuItem: QueryList<UpsHamMenuItemComponent>;

    constructor(private renderer: Renderer2, private vp: ViewPorts) {

        this.globalClick = this.renderer.listen('body', 'click', (e) => {
            this.bodyClicked(e);
        });

        this.globalKeydown = this.renderer.listen('body', 'keydown', (e) => {
            if (e.which && e.which == 27) {
                this.hide();
            } else if (e.keyCode && e.keyCode == 27) {
                this.hide();
            }
        });

        vp.viewPortChange().subscribe((val) => {
            this.vpSize = val;
        });

    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {
        var tvDrawerContainer = $(this.toggleDrawerContainer.nativeElement).detach();
        $('body').prepend(tvDrawerContainer);
    }

    ngAfterContentInit(): void {
        this.menuItem.forEach((comp, i) => {
            if (comp.isFocusable) {
                this.focusableIndexes.push(i);
            }

            comp.itemMsgs.subscribe((data: any) => {
                if (data.msg == 'focus') {
                    this.focusedItemIndex = i;
                } else if (data.msg == 'closeMenu') {
                    this.hide();
                }
            });
        });
    }

    public show(el: HTMLElement): void {
        if (!el) {
            console.error('Error when opening toggle view: Toggle View requires an element to attach to.');
            return;
        }

        if (this.toggleMenuShown) {
            this.hide();
            return;
        }

        this.toggleMenuShown = true;
        this.closeFocusElm = el;
        this.menuItem.toArray()[this.focusableIndexes[0]].setFocus();
    }

    public hide(): void {
        var wasOpen: boolean = this.toggleMenuShown;
        this.toggleMenuShown = false;

        if (wasOpen) {
            this.closeFocusElm.focus();
        }
    }

    public bodyClicked(e: Event): void {
        if (!this.closeFocusElm) {
            return;
        }

        if (e.target == this.closeFocusElm || $.contains(this.closeFocusElm, e.target)) {
            return;
        }
        this.hide();
    }

    public calculateDrawerTop(): string {
        var focusElTop: number = $(this.closeFocusElm).offset().top;
        var focusElHeight: number = $(this.closeFocusElm).outerHeight();

        return (focusElTop + focusElHeight).toString() + 'px';
    }

    public calculateDrawerLeft(): string {
        var focusElLeft: number = $(this.closeFocusElm).offset().left;
        var windowWidth: number = $(window).width();

        if (this.vpSize.isXSVP) {
            return '20px';
        }

        if (focusElLeft > (windowWidth / 2)) {
            return 'auto';
        }

        return focusElLeft.toString() + 'px';
    }

    public calculateDrawerRight(): string {
        var focusElLeft: number = $(this.closeFocusElm).offset().left;
        var focusElWidth: number = $(this.closeFocusElm).outerWidth();
        var windowWidth: number = $(window).width();

        if (this.vpSize.isXSVP) {
            return '20px';
        }

        if (focusElLeft > (windowWidth / 2)) {
            return ((windowWidth - focusElLeft) - focusElWidth).toString() + 'px';
        }

        return 'auto';
    }

    public calculateArrowLeft(): string {
        var focusElWidth: number = $(this.closeFocusElm).outerWidth();
        var focusElLeft: number = $(this.closeFocusElm).offset().left;
        var windowWidth: number = $(window).width();

        if (this.vpSize.isXSVP) {
            return (focusElLeft - 20).toString() + 'px';
        }

        if (focusElLeft > (windowWidth / 2)) {
            return 'auto';
        }

        if (focusElWidth < 31) {
            return '0';
        }

        return ((focusElWidth / 2) - 15).toString() + 'px';
    }

    public calculateArrowRight(): string {
        var focusElWidth: number = $(this.closeFocusElm).outerWidth();
        var focusElLeft: number = $(this.closeFocusElm).offset().left;
        var windowWidth: number = $(window).width();
        var docWidth: number = $(document).width();

        if (this.vpSize.isXSVP) {
            return 'auto';
        }

        if (focusElLeft > (windowWidth / 2)) {
            if (focusElWidth < 31) {
                return '0';
            }

            return ((focusElWidth / 2) - 15).toString() + 'px';
        }

        return 'auto';
    }

    toggleDrawerContainerClick(e: Event) {
        e.stopPropagation();
    }

}


